<template>
    <div id="login">
        <FLogoScroller class="logo" />
        <div class="zs-pane login-form">
            <WorkstationLoginForm v-if="isWorkstationedClient" />
            <EmailLoginForm v-else />
        </div>
        <div id="login-terms">
            By signing in, you agree to our
            <a href="https://app.termly.io/policy-viewer/policy.html?policyUUID=e8482c32-22e5-414b-bafa-f8215327847d" target="_blank">Terms of Use</a>
            and
            <a href="https://app.termly.io/policy-viewer/policy.html?policyUUID=3aa9812c-cb8e-4f20-b3df-128bb3d5122b" target="_blank"
                >Privacy Policy</a
            >.
        </div>
        <CIncidentIcon id="incident-icon" />
    </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';

import { useIdleUpdateReload } from '@/shared/helpers/update-reload.helpers';
import { SSEService } from '@/shared/services/sse';

import { WorkstationBridge } from '../workstation/helpers/bridge.ts';
import EmailLoginForm from './login/f-email-login-form.vue';
import FLogoScroller from './login/f-logo-scroller.vue';
import WorkstationLoginForm from './login/f-workstation-login-form.vue';
import CIncidentIcon from './qab/c-incident-icon.vue';

const isWorkstationedClient = WorkstationBridge.isWithinZynoWorkstation();

onMounted(() => {
    SSEService.disconnect();
});

useIdleUpdateReload(5_000);
</script>

<style scoped>
@reference '#tw.css';

#login {
    @apply flex-1 flex items-center justify-center;
}

.zs-pane {
    @apply mt-12 p-6;
}

#login-terms {
    @apply absolute bottom-12 text-sm mt-4 text-ink-3;

    a {
        @apply text-sm text-ink-4;
    }
}

#incident-icon {
    @apply absolute bottom-24 text-4xl cursor-pointer;
}
</style>
